<template>
  <div class="h-full menu-list">
    <div class="bg-light-gray-400 pt-2 px-0 sm:pb-0 sm:pt-0">
      <w-tabs v-model="activeTab" :tabs="tabs" classes="px-5" />
    </div>
    <section class="sm:mt-6 sm:px-4 sm:w-full w-[896px] weiby-container mt-6">
      <w-loading v-if="gettingMenuList" :is-full-page="false" color="primary-500" />
      <div v-else-if="!gettingMenuList && !formattedMenu.length">
        <h2 class="text-center text-xl">
          目前沒有任何訂購喔！
        </h2>
        <img
          alt="No Menu List Items Image"
          class="mx-auto my-10"
          src="@/assets/images/no-menu-list-items-image.jpg"
        />
      </div>
      <menu-list-item
        v-else
        :items="formattedMenu"
      />
    </section>
  </div>
</template>

<script>
import MenuList from './MenuList';

export default MenuList;
</script>

<style lang="scss" scoped>
@import 'MenuList';
</style>
